import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { LeftNavComponent } from './left-nav/left-nav.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './auth/login/login.component';
import { AuthGuard } from './auth/auth.guard';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RestService } from './services/common/rest.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SubHeaderComponent } from './sub-header/sub-header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { MenubarModule } from 'primeng/menubar';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FilterPipe } from './custome-filterpipe';
import { SiteSwitchComponent } from './site-switch/site-switch.component';
import { BanksService, UserService } from './services/common';
import { AppInterceptorService } from './shared/app-interceptor.service';
import { JwtService } from './auth/jwtservice';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthSessionService } from './auth/auth-session.service';
import { ExportService } from './services/common/export.service';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { InputSwitchModule } from 'primeng/inputswitch';
import { NgApexchartsModule } from 'ng-apexcharts';
import { SharedModule } from 'primeng/api';
import { MenuItemComponent } from './left-nav/menu-item/menu-item.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { UserAccountProfileComponent } from './user-account-profile/user-account-profile.component';
import { CommoncomponentsModule } from "./common-components/common-components.module";
import { SalesService } from './main-layout/sales';
import { VaultModule } from './vault/vault.module';
import { HomeComponent } from './main-layout/home/home.component';
import { AggregatorComponent } from './auth/aggregator/aggregator.component';
import { DeveloperComponent } from './auth/developer/developer.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LeftNavComponent,
    LoginComponent,
    SubHeaderComponent,
    SiteSwitchComponent,
    MenuItemComponent,
    MainLayoutComponent,
    AuthLayoutComponent,
    UserAccountProfileComponent,
    HomeComponent,
    AggregatorComponent,
    DeveloperComponent
  ],

  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ToastrModule.forRoot({
      toastClass: 'ngx-toastr',
      closeButton: true,
      timeOut: 3000,
      extendedTimeOut: 1000,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    DialogModule,
    ButtonModule,
    DropdownModule,
    MenubarModule,
    NgxSpinnerModule,
    InputSwitchModule,
    NgApexchartsModule,
    SharedModule,
    CommoncomponentsModule,
    VaultModule
  ],

  providers: [DatePipe, AuthGuard, RestService, FilterPipe, BanksService, UserService, JwtService, JwtHelperService, provideAnimationsAsync(),
    AppInterceptorService, { provide: HTTP_INTERCEPTORS, useClass: AppInterceptorService, multi: true }, ExportService, DecimalPipe, SalesService, AuthSessionService
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
